import { render, staticRenderFns } from "./DiscountDetail.vue?vue&type=template&id=2e3fafab&scoped=true&"
import script from "./DiscountDetail.vue?vue&type=script&lang=js&"
export * from "./DiscountDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiscountDetail.vue?vue&type=style&index=0&id=2e3fafab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fafab",
  null
  
)

export default component.exports